import { CBContext, CBEventInfo } from "../../codebricks-runtime/CBModels";
import { DrillSet, ObjectDeepMerge } from "../../codebricks-runtime/CBUtil";
import { CodeBrick } from "../../codebricks-runtime/CodeBrick";
import { PivotTable } from "../../shared-funcs/PivotTable";

export class ci_data_webcomponent extends HTMLElement {
    ci: web_ci_data | undefined;
    constructor() {
        super();
    }
    connectedCallback() {
        if(!this.ci) {
            let context = (globalThis as any).codebricks_context;
            let cid = this.getAttribute('cid') as string;
            let name = this.getAttribute('name') as string;
            let dc = this.getAttribute('dc') as string;
                let idx = this.getAttribute('idx') as string;
                let container_id = this.getAttribute('container_id') as string;
            this.ci = new web_ci_data(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if(this.ci) {
            this.ci.destructor();
        }
    }
}
customElements.define('ci-data', ci_data_webcomponent);

export class web_ci_data extends CodeBrick {

    element: HTMLElement;
    data: any;
    prev_data = "";

    constructor(context: CBContext, cid:string, name: string, dc: string, idx: number, container_id: string, element: HTMLElement) {
        super(context, cid, name, dc, idx, container_id);
        this.element = element;
    }

    async cb_event(input: string, cfg: any, info: CBEventInfo): Promise<any> {
        //console.log("ci-data "+this.brick_id+" cb_event "+input+" "+JSON.stringify(cfg));
        if(input == "data") {
            if(cfg.ignore_unchanged || cfg.ingore_unchanged) {//fixed typo in spec
                if(this.prev_data == JSON.stringify(cfg.value)) {
                    return;
                }
            } 
            this.data = cfg.value;

            //group
            if(cfg.group_by && cfg.group_by.group_cols && cfg.group_by.group_cols.length > 0) {
                this.data = PivotTable.groupData(this.data, cfg.group_by.group_cols, cfg.group_by.count_cols, cfg.group_by.sum_cols);
            }

            //console.log('Grouped data: '+JSON.stringify(data));

            if(cfg.pivot && cfg.pivot.rows && cfg.pivot.rows.length > 0 &&
                cfg.pivot.columns && cfg.pivot.columns.length > 0 &&
                cfg.pivot.data_columns && cfg.pivot.data_columns.length > 0 ) {
    
                this.data = PivotTable.pivotData(this.data, cfg.pivot.rows[0], cfg.pivot.columns[0], cfg.pivot.data_columns, false);
            }

            let dont_emit = false;
            if(cfg.ingore_initial) {
                if(this.prev_data === "") {
                    dont_emit = true;
                }
            }
            this.prev_data = JSON.stringify(this.data);
            if(!dont_emit) {

                if(cfg.no_event) {
                    this.cb_emit({ "@" : this.data }, undefined, true);
                }
                else {
                    return { "@" : this.data };
                }
            }
        }
        else if(input == "merge") {
            if(cfg.value !== "") {
                ObjectDeepMerge(this.data || {}, cfg.value);

                return { "@" : this.data  };
            }
        }
        else if(input == "set_property") {
            if(this.data && cfg.value !== "" && cfg.path !== undefined) {
                this.data = DrillSet(this.data, cfg.path, cfg.value);
                return { "@" : this.data  };
            }
        }
        else if(input == "push") {
            if(cfg.value !== "") {
                this.data = this.data || [];
                if(Array.isArray(this.data)) {
                    this.data.push(cfg.value);
                    return { "@" : this.data  };
                }         
            }
        }
    }
    cb_validate(): boolean {
        return this.validate_sources("");
    }
    cb_initial_cement(cements: { [child_idx: number]: any }) {
    }
    cb_update_cement(child_idx: number, cement: any, row_idx: number) {
    }
    cb_status(status: string): void {
        this.emit_state(status);
    }
    cb_snapshot() {}
}